import { useMutation } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useHousehold } from '@/context/HouseholdContext'

// Troca o idioma da interface. É POR USUÁRIO: grava em profiles.locale do
// usuário logado (upsert), não no household compartilhado. Reflete na hora via refresh().
export function useUpdateLanguage() {
  const { userId, refresh } = useHousehold()
  return useMutation({
    mutationFn: async (lang: string) => {
      if (!userId) throw new Error('Sem usuário autenticado')
      const { error } = await supabase
        .from('profiles')
        .upsert({ user_id: userId, locale: lang }, { onConflict: 'user_id' })
      if (error) throw error
    },
    onSuccess: () => refresh(),
  })
}
